document.querySelectorAll('[data-variety-filter-root]').forEach((root) => {
  const colourSelect = root.querySelector('[data-filter-colour]');
  const colourGroup = root.querySelector('[data-filter-colour-group]');
  const bloomSelect = root.querySelector('[data-filter-bloom]');
  const availSelect = root.querySelector('[data-filter-available]');
  if (!colourGroup && !colourSelect && !bloomSelect && !availSelect) return;

  const cards = Array.from(root.querySelectorAll('[data-variety-grid] .variety-card'));
  const countEl = root.querySelector('[data-filter-count]');
  const emptyEl = root.querySelector('[data-filter-empty]');

  let colourPick = '';
  if (colourGroup) {
    colourGroup.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-filter-colour-pick]');
      if (!btn) return;
      colourPick = btn.dataset.filterColourPick || '';
      colourGroup.querySelectorAll('[data-filter-colour-pick]').forEach((b) => {
        b.setAttribute('aria-pressed', String(b === btn));
      });
      apply();
    });
  }

  function apply() {
    const colour = colourGroup ? colourPick : (colourSelect ? colourSelect.value : '');
    const bloom = bloomSelect ? bloomSelect.value : '';
    const avail = availSelect ? availSelect.value : '';
    let visible = 0;

    cards.forEach((card) => {
      const show = (!colour || card.dataset.colour === colour)
        && (!bloom || card.dataset.bloomMonth === bloom)
        && (!avail || card.dataset.available === avail);
      // style.display, not hidden: .variety-card is display:flex and [hidden] loses that fight.
      card.style.display = show ? '' : 'none';
      if (show) visible += 1;
    });

    if (countEl) {
      countEl.hidden = false;
      countEl.textContent = `Showing ${visible} of ${cards.length} varieties`;
    }
    if (emptyEl) emptyEl.hidden = visible !== 0;
  }

  [colourSelect, bloomSelect, availSelect].forEach((select) => {
    if (select) select.addEventListener('change', apply);
  });

  apply();
});
